import { SingleResponse } from "../../tastyworks"
import type HttpClient from "../../tastyworks/http"
import { RecoveryCodesStatus } from "../../tastyworks/recovery-codes"

export class RecoveryCodesService {
  //@ts-ignore
  private readonly recoveryCodesClient: HttpClient

  constructor(userMeClient: HttpClient) {
    this.recoveryCodesClient = userMeClient.nested("recovery-codes")
  }

  // TODO: KRKC-11 Pass 2 — replace mock with:
  //   this.recoveryCodesClient.show(new RecoveryCodesStatus(), RECOVERY_CODES_STATUS_DESER.update, "")
  // eslint-disable-next-line @typescript-eslint/require-await
  readonly getStatus = async () => {
    const status = new RecoveryCodesStatus()
    status.codesRemaining = 10
    status.totalCodes = 10
    status.generatedAt = new Date("2026-07-10T15:04:49.663Z")
    const response = new SingleResponse<RecoveryCodesStatus>()
    response.data = status
    return response
  }

  // TODO: KRKC-13 Pass 2 — replace mock with:
  //   const helper = await this.recoveryCodesClient.postJson("generate", {})
  //   return parseSingleResponse(helper, (data) => ({ codes: data.getPrimitiveArray("recovery-codes") as string[] }))
  // eslint-disable-next-line @typescript-eslint/require-await
  readonly generate = async (): Promise<
    SingleResponse<{ codes: string[] }>
  > => {
    const response = new SingleResponse<{ codes: string[] }>()
    response.data = {
      codes: [
        "aa11-bb22",
        "cc33-dd44",
        "ee55-ff66",
        "gg77-hh88",
        "ii99-jj00",
        "kk11-ll22",
        "mm33-nn44",
        "oo55-pp66",
      ],
    }
    return response
  }
}
